import styled from 'styled-components';
import { UserIcon } from '../common/Icons';

const PhoneStage = styled.div`
  display: flex; justify-content: center; min-width: 0; padding: 14px; border-radius: 12px;
  background: ${({ theme }) => theme.name === 'dark' ? '#14161A' : '#ECEEF1'};
`;
const PhoneScreen = styled.section`
  width: 290px; max-width: 100%; height: clamp(340px, calc(100dvh - 210px), 540px);
  display: flex; flex-direction: column; overflow: hidden; box-sizing: border-box;
  border: 6px solid ${({ theme }) => theme.name === 'dark' ? '#393B42' : '#363B45'};
  border-radius: 32px; background: ${({ theme }) => theme.name === 'dark' ? '#17181B' : '#F4F5F7'};
  color: ${({ theme }) => theme.name === 'dark' ? '#F4F3F0' : '#252932'};
  box-shadow: 0 14px 34px ${({ theme }) => theme.name === 'dark' ? '#00000070' : '#20242C33'};
`;
const PhoneStatus = styled.div`
  height: 30px; padding: 4px 18px 0; flex-shrink: 0; display: flex; align-items: center; justify-content: space-between;
  background: ${({ theme }) => theme.name === 'dark' ? '#090A0C' : '#FFFFFF'};
  font-size: 11px; font-weight: 700; font-variant-numeric: tabular-nums;
`;
const PhoneHeader = styled.div`
  min-height: 60px; padding: 0 14px; flex-shrink: 0; display: flex; align-items: center; gap: 9px;
  background: ${({ theme }) => theme.name === 'dark' ? '#090A0C' : '#FFFFFF'};
  border-bottom: 1px solid ${({ theme }) => theme.name === 'dark' ? '#27292F' : '#E3E5EA'};
  strong { font-size: 14px; font-weight: 600; }
  .more { margin-left: auto; font-size: 20px; line-height: 1; }
`;
const PhoneAvatar = styled.div`
  width: 30px; height: 30px; border-radius: 50%; display: grid; place-items: center;
  background: ${({ theme }) => theme.name === 'dark' ? '#3B3D43' : '#E4E6EB'};
  color: ${({ theme }) => theme.name === 'dark' ? '#C2C5CB' : '#747B87'};
  svg { width: 16px; height: 16px; }
`;
const PhoneConversation = styled.div`
  flex: 1; min-height: 0; overflow-y: auto; padding: 16px 12px;
`;
const PhoneDate = styled.div`
  margin: 8px 0 24px; text-align: center; font-size: 11px;
  color: ${({ theme }) => theme.name === 'dark' ? '#999BA3' : '#6A707B'};
`;
const PhoneMessage = styled.div`display: flex; align-items: flex-end; gap: 6px;`;
const PhoneBubble = styled.div`
  max-width: 78%; padding: 11px 13px; border-radius: 17px 17px 17px 5px;
  background: ${({ theme }) => theme.name === 'dark' ? '#35351F' : '#E5E7D3'};
  color: ${({ theme }) => theme.name === 'dark' ? '#F7F6ED' : '#292D22'};
  font-size: 13px; line-height: 1.55; white-space: pre-wrap; overflow-wrap: anywhere;
`;
const PhoneSenderTag = styled.span`display: block; font-weight: 600;`;
const PhoneSubject = styled.strong`display: block; margin: 2px 0 8px; font-size: 13px;`;
const PhoneAttachment = styled.img`display: block; width: 100%; max-height: 190px; margin: 0 0 8px; border-radius: 5px; object-fit: contain;`;
const PhoneMessageTime = styled.span`
  flex-shrink: 0; color: ${({ theme }) => theme.name === 'dark' ? '#97999F' : '#767C85'};
  font-size: 10px; white-space: nowrap;
`;
const PhoneComposer = styled.div`
  display: flex; align-items: center; gap: 8px; padding: 10px 12px; flex-shrink: 0;
  background: ${({ theme }) => theme.name === 'dark' ? '#090A0C' : '#FFFFFF'};
  color: ${({ theme }) => theme.name === 'dark' ? '#B7B9C1' : '#7A818E'};
  .plus { font-size: 24px; line-height: 1; }
  .field { height: 32px; flex: 1; display: flex; align-items: center; padding: 0 12px; border-radius: 18px;
    background: ${({ theme }) => theme.name === 'dark' ? '#2B2D32' : '#F0F1F4'}; font-size: 11px; }
`;
const PhoneGesture = styled.div`
  height: 17px; flex-shrink: 0; display: grid; place-items: center;
  background: ${({ theme }) => theme.name === 'dark' ? '#090A0C' : '#FFFFFF'};
  &::after { content: ''; width: 82px; height: 4px; border-radius: 3px;
    background: ${({ theme }) => theme.name === 'dark' ? '#767980' : '#9CA2AB'}; }
`;

const KakaoStage = styled.section`
  min-height: 390px; box-sizing: border-box; padding: 24px 22px 32px; border-radius: 12px;
  background: ${({ theme }) => theme.name === 'dark' ? '#344453' : '#BFD0DE'};
  color: ${({ theme }) => theme.name === 'dark' ? '#E7EDF2' : '#464D54'};
`;
const KakaoDate = styled.div`
  display: flex; align-items: center; gap: 12px; margin-bottom: 32px;
  font-size: 13px; text-align: center; white-space: nowrap; font-variant-numeric: tabular-nums;
  &::before, &::after { content: ''; height: 1px; flex: 1; background: ${({ theme }) => theme.name === 'dark' ? '#687B8B' : '#A6B8C7'}; }
`;
const KakaoThread = styled.div`
  display: grid; grid-template-columns: 46px minmax(0, 1fr); gap: 12px;
`;
const KakaoAvatar = styled.div`
  width: 46px; height: 46px; border-radius: 17px;
  background: ${({ theme }) => theme.name === 'dark' ? '#E8EDF0' : '#FFFFFF'};
`;
const KakaoChannel = styled.div`
  margin: 1px 0 12px; font-size: 13px; font-weight: 600;
`;
const KakaoMessageRow = styled.div`display: flex; align-items: flex-end; gap: 8px; min-width: 0;`;
const KakaoCard = styled.div`
  position: relative; width: min(100%, 390px); min-width: 0; overflow: visible;
  border-radius: 10px; background: ${({ theme }) => theme.name === 'dark' ? '#282C32' : '#FFFFFF'};
  color: ${({ theme }) => theme.name === 'dark' ? '#F0F2F4' : '#3E4146'};
`;
const KakaoCardHeader = styled.div`
  padding: 11px 15px; border-radius: 10px 10px 0 0;
  background: ${({ theme }) => theme.name === 'dark' ? '#F2DC19' : '#FEE500'};
  color: #303238; font-size: 15px; font-weight: 700;
`;
const KakaoBadge = styled.span`
  position: absolute; top: -14px; right: -14px; width: 42px; height: 42px;
  display: grid; place-items: center; border-radius: 50%; background: #3F4145;
  color: #FFFFFF; font-size: 11px; font-weight: 700;
`;
const KakaoCardBody = styled.div`
  padding: 18px 15px 20px; font-size: 15px; line-height: 1.65;
  white-space: pre-wrap; overflow-wrap: anywhere;
`;
const KakaoTime = styled.span`
  flex-shrink: 0; padding-bottom: 3px; font-size: 11px; white-space: nowrap;
  font-variant-numeric: tabular-nums;
`;

interface MessagePreviewMockupProps {
  variant: 'sms' | 'kakao';
  text: string;
  sender?: string;
  sentAt?: string;
  showWebSender?: boolean;
  imageUrl?: string;
  subject?: string;
}

export default function MessagePreviewMockup({ variant, text, sender, sentAt, showWebSender = false, imageUrl, subject }: MessagePreviewMockupProps) {
  const date = sentAt ? new Date(sentAt) : null;
  const validDate = date && !Number.isNaN(date.getTime()) ? date : null;
  const dateLabel = validDate ? new Intl.DateTimeFormat('ko-KR', { year: 'numeric', month: 'long', day: 'numeric' }).format(validDate) : sentAt ? '—' : '오늘';
  const timeLabel = validDate ? new Intl.DateTimeFormat('ko-KR', { hour: 'numeric', minute: '2-digit', hour12: true }).format(validDate) : sentAt ? '—' : '방금';

  if (variant === 'kakao') return <KakaoStage aria-label="알림톡 메시지 화면">
    <KakaoDate>{dateLabel}</KakaoDate>
    <KakaoThread>
      <KakaoAvatar aria-hidden="true" />
      <div>
        <KakaoChannel>카카오톡 채널</KakaoChannel>
        <KakaoMessageRow>
          <KakaoCard>
            <KakaoCardHeader>알림톡 도착</KakaoCardHeader>
            <KakaoBadge aria-hidden="true">kakao</KakaoBadge>
            <KakaoCardBody>{text}</KakaoCardBody>
          </KakaoCard>
          <KakaoTime>{timeLabel}</KakaoTime>
        </KakaoMessageRow>
      </div>
    </KakaoThread>
  </KakaoStage>;

  return <PhoneStage>
    <PhoneScreen aria-label="문자 메시지 화면">
      <PhoneStatus aria-hidden="true"><span>9:41</span><svg width="35" height="12" viewBox="0 0 35 12" fill="currentColor"><path d="M0 9h3v3H0zm5-3h3v6H5zm5-3h3v9h-3zm5-3h3v12h-3z"/><rect x="23" y="2" width="10" height="8" rx="2"/></svg></PhoneStatus>
      <PhoneHeader><span aria-hidden="true">‹</span><PhoneAvatar aria-hidden="true"><UserIcon /></PhoneAvatar><strong>{sender || '문자 메시지'}</strong><span className="more" aria-hidden="true">⋮</span></PhoneHeader>
      <PhoneConversation>
        <PhoneDate aria-hidden="true">{dateLabel}</PhoneDate>
        <PhoneMessage><PhoneBubble aria-live="polite">{showWebSender && <PhoneSenderTag>[Web발신]</PhoneSenderTag>}{subject && <PhoneSubject>{subject}</PhoneSubject>}{imageUrl && <PhoneAttachment src={imageUrl} alt="첨부 이미지" />}<span>{text}</span></PhoneBubble><PhoneMessageTime aria-hidden="true">{timeLabel}</PhoneMessageTime></PhoneMessage>
      </PhoneConversation>
      <PhoneComposer aria-hidden="true"><span className="plus">＋</span><span className="field">메시지 입력</span><span>◉</span></PhoneComposer>
      <PhoneGesture aria-hidden="true" />
    </PhoneScreen>
  </PhoneStage>;
}
